<template>
    <div class="see_more">
        <div>
            <a href='https://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui'> 查看更多请下载爱股票APP</a>
        </div>
        <p>京ICP备15042420</p>
    </div>
</template>
<script>
export default {
    name: 'readMore',
    props: {
        msg: String
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.see_more {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 12px 24px;

    >div {
        height: 44px;
        border: 1px solid #FF9A9B;
        margin-top: 15px;
        border-radius: 4px;
        line-height: 44px;
        text-align: center;
        font-size: 15px;
        background: #ffffff;

        >a {
            display: inline-block;
            width: 100%;
            height: 100%;
            color: #FE484A;
        }
    }

    >p {
        color: #939393;
        line-height: 16px;
        font-size: 11px;
        text-align: center;
    }
}
</style>